/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconSize} from '../types/types';

export type VolumeMuteIconProps = {
  color?: string;
  size?: IconSize | number;
}

/*
 * Defines the Design Language System (DLS) Volume Mute Icon component.
 */
export const VolumeMuteIcon = ({size = 20, color = dlsColor('grey3')}: VolumeMuteIconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill='none'>
      <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z" fill={color} />
    </svg>
  );
};

export default VolumeMuteIcon;
